import { tvpil } from '../compat/tvpil';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchChannelAssets, fetchEntitledChannels } from './queryFunctions';
import { createChannelCollectionQueryOptions } from './queryOptions';

type FetchChannelCollectionQueryArgs = {
  referenceId: string;
};

export function fetchChannelCollectionQuery({ referenceId }: FetchChannelCollectionQueryArgs) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return Promise.resolve();
  }

  if (!category.channels[0]) {
    return Promise.resolve();
  }

  return queryClient.fetchQuery(createChannelCollectionQueryOptions(category));
}

export function fetchEntitledChannelsQuery() {
  return queryClient.fetchQuery({
    queryKey: queryKeys.entitledChannels,
    queryFn: fetchEntitledChannels,
    staleTime: Infinity,
  });
}

export function fetchChannelsQuery() {
  return queryClient.fetchQuery({
    queryKey: queryKeys.channelAssets,
    queryFn: fetchChannelAssets,
    staleTime: Infinity,
  });
}
